import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type FusionMachine } from "@packsize/schemas/machines";

import { getFusionMachine } from "@/api/machines/fusion-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { FUSION_MACHINES_QUERY_KEY } from "./query-keys";

type UseFusionMachineQueryOptions = UseMachinesQueryOptions<FusionMachine | null, Error>;

export const getFusionMachineQuery = (
	machineId: string | null | undefined,
	options?: UseFusionMachineQueryOptions,
) => ({
	queryKey: [...FUSION_MACHINES_QUERY_KEY, { machineId }],
	queryFn: () => getFusionMachine(machineId || ""),
	...options,
	enabled: Boolean(machineId) && (options?.enabled ?? true),
});

export const useFusionMachine = (
	machineId: string | null | undefined,
	options?: UseFusionMachineQueryOptions,
): UseQueryResult<FusionMachine | null, Error> => {
	return useQuery<FusionMachine | null, Error>(getFusionMachineQuery(machineId, options));
};
